import { Container } from "components";
import { Formik, Field, Form } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import api from "services/api";
import Footer from "components/footer";
import { RELATIONS } from "services/api.config";
import ApplicationForm from "pages/billings_plans/components/applicationForm";
import moment from "moment";
import { useAuth } from "hooks";
import { toast } from "react-toastify";

export const EnrollApplicationDetails = () => {
  const [relations, setRelations] = useState([]);
  const [countries, setContries] = useState([]);
  const [activeMembership] = useState({});
  const paramas = useParams();
  const { user } = useAuth();
  const [store, Setstore] = useState([]);
  const [availableSlots, setAvailableSlots] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [initialValues] = useState([
    {
      membership_id: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      phone_no: "",
      email: "",
      // img: "",
      // imgpath: "",
      dob: "",
      sex: "",
      relation: "",
      country_id: "",
      aadhar_number: "",
      user_image: "",
    },
  ]);

  const membershipData = {
    membership_id: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    phone_no: "",
    email: "",
    // img: "",
    // imgpath: "",
    dob: "",
    sex: "",
    relation: "",
    country_id: "", // Initialize country as null or any default value
    // nationality: "",
    aadhar_number: "",
    user_image: "",
  };

  const validationSchema = Yup.object().shape({
    members: Yup.array().of(
      Yup.object().shape({
        first_name: Yup.string()
          .required("Required")
          .min(3, "First name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        middle_name: Yup.string()
          // .required("Required")
          // .min(3, "Middle name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        last_name: Yup.string()
          // .required("Required")
          // .min(3, "Last name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        phone_no: Yup.string()
          .required("Required")
          .length(10, "Phone number must be exactly 10 digits")
          .matches(/[0-9]+$/, "only numeric"),
        email: Yup.string().email("Invalid email").required("Required"),
        // img: Yup.string(),
        dob: Yup.date().required("Required"),
        sex: Yup.string().required("Required"),
        relation: Yup.string(),
        // nationality: Yup.string().required("Required"),
        nationality: Yup.number().required("Required"),
        aadhar_number: Yup.string()
          .required("Required")
          .matches(/^[0-9]{12}$/, "Must be exactly 12 digits"),
      })
    ),
    agree: Yup.boolean(),
    // .oneOf([true], "You must accept the terms and conditions")
    // .required("You must accept the terms and conditions"),
  });
  const countriesFetch = React.useCallback(async () => {
    try {
      const response = await api.get("/countries");
      const countriesList = response?.data?.data?.countries;
      setContries(countriesList);
      console.log("countriesFetch:", countriesList);
    } catch (error) {
      console.log("countriesFetch:", error);
    }
  }, []);
  const fetchRelaction = React.useCallback(async () => {
    try {
      const response = await api.get(`${RELATIONS}`);
      const relationList = response?.data?.data?.relations;
      setRelations(relationList);
      console.log("relation fetch:", relationList);
    } catch (error) { }
  }, []);
  const fetchenrolledUser = React.useCallback(async () => {
    console.log("=== fetchenrolledUser called ===");
    console.log("enrollId:", paramas?.id);
    try {
      const response = await api.get(`/enrolled-plans?enrollId=${paramas?.id}`);
      console.log("Full API Response:", response?.data);
      const usersList = response?.data?.data?.memberApplication;
      Setstore(usersList);
      console.log("fetchenrolledUser - usersList:", usersList);
      console.log("First item structure:", usersList?.[0]);
      
      // Extract available_slots from response
      // Check both direct available_slots and nested enrollUser.available_slots
      let availableSlotsValue = null;
      
      if (usersList && usersList.length > 0) {
        // Try to find available_slots in any item of the array
        for (let i = 0; i < usersList.length; i++) {
          const item = usersList[i];
          
          // First try direct available_slots
          if (item?.available_slots) {
            availableSlotsValue = item.available_slots;
            console.log(`Found available_slots directly in item ${i}:`, availableSlotsValue);
            break;
          }
          // Then try nested enrollUser.available_slots
          else if (item?.enrollUser?.available_slots) {
            availableSlotsValue = item.enrollUser.available_slots;
            console.log(`Found available_slots in enrollUser of item ${i}:`, availableSlotsValue);
            break;
          }
        }
        
        if (availableSlotsValue !== null && availableSlotsValue !== undefined && availableSlotsValue !== "") {
          const slots = parseInt(String(availableSlotsValue), 10);
          if (!isNaN(slots) && slots >= 0) {
            console.log("Setting availableSlots to:", slots);
            setAvailableSlots(slots);
          } else {
            console.log("Invalid available_slots value:", availableSlotsValue);
            setAvailableSlots(0);
          }
        } else {
          console.log("available_slots not found in any memberApplication item");
          console.log("Searched structure:", JSON.stringify(usersList, null, 2));
          setAvailableSlots(0);
        }
      } else {
        console.log("No memberApplication found or empty array");
        setAvailableSlots(0);
      }
    } catch (error) {
      console.log("getCall error:", error);
      setAvailableSlots(0);
    }
  }, [paramas?.id]);
  useEffect(() => {
    countriesFetch();
    fetchRelaction();
    fetchenrolledUser();
  }, [countriesFetch, fetchRelaction, fetchenrolledUser]);
  
  // Debug: Log availableSlots changes
  useEffect(() => {
    console.log("availableSlots state changed to:", availableSlots);
  }, [availableSlots]);
  const addMemBeship = (values, setValues) => {
    const updateValues = {
      members: [...values.members, { ...membershipData, relation: "" }], //this is no auto fill relation second add member
    };
    setValues(updateValues);
  };


  const handleSubmitEnrolledUser = async (values) => {
    let payload = [];
    console.log("values:", values);
    values.members.forEach((mem) => {
      let obj = { ...mem };
      // delete obj.imgpath;
      obj.dob = moment(obj.dob).format("DD-MM-YYYY");
      payload.push(obj);
    });
    const formData = new FormData();
    console.log("formdata:", formData);
    payload.forEach((res, i) => {
      Object.entries(res).forEach((mem) => {
        formData.append(`${mem[0]}[${i}]`, mem[1]);
      });
    });
    formData.append("membership_id", store[0]?.membership_id);
    console.log("store state:", store);
    formData.append("user_id", user?.user_id);
    formData.append("enroll_id", store[0]?.enroll_id);
    // console.log("payload:",payload);
    // console.log("formdata:",formData.values);
    // console.log("user_id:",user?.user_id);
    // console.log("membership_id:",store[0]?.membership_id);
    // console.log("enroll_id:",store[0]?.enroll_id);

    try {
      const response = await api.post("/enrolled-plan", formData);
      console.log("enrolleapplicationDetails submit:", response?.data?.message);
      // setSuccessToaster(response?.data?.message || "Added Succefully");
      toast.success(response?.data?.message || "Added Succefully");
      navigate("/enrolledPlans");
    } catch (error) {
      console.log("enrolleapplicationDetails submit error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/enrolledPlans">plans</Link>
              </li>
              <li class="breadcrumb-item active">Add member</li>
            </ol>
          </nav>
          <h5 className="ms-4 ">Plan: {store[0]?.membership_plan?.title}</h5>
          <Formik
            initialValues={{ members: initialValues }}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values) => {
              console.log("handlesubmit :", values);
              handleSubmitEnrolledUser(values);
            }}
          >
            {({ values, setFieldValue, errors, setValues, setFieldError }) => (
              <>
                <Form>
                  {values?.members?.map((mem, i) => {
                    const isLastForm = values?.members?.length - 1 === i;
                    console.log(`Rendering ApplicationForm ${i}:`, {
                      isLastForm,
                      availableSlots,
                      totalMembers: values?.members?.length
                    });
                    return (
                      <ApplicationForm
                        setFieldValue={setFieldValue}
                        relations={relations}
                        countries={countries}
                        values={values}
                        addMemBeship={addMemBeship}
                        setValues={setValues}
                        mem={mem}
                        isLast={isLastForm}
                        formIndex={i}
                        availableSlots={availableSlots}
                      // handleClick={handleClick}
                      // handleResetImage={handleResetImage}
                      />
                    );
                  })}
                  <div class="card mb-4  mx-4">
                    <h5 class="card-header">Consent</h5>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12 mb-1">
                          <div class="mb-3">
                            <p>
                              <Field
                                class="form-check-input me-2"
                                type="checkbox"
                                name="agree"
                              />{" "}
                              I agree to &nbsp;
                              <Link to="/termsConditions" target="blank">
                                Terms and Conditions
                              </Link>{" "}
                              and{" "}
                              <Link to="/privacyPolicy" target="blank">
                                Privacy Policy
                              </Link>{" "}
                              <br />
                            </p>
                            <div className="invalid-form">{errors.agree}</div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2">
                        <button
                          type={values?.agree ? "submit" : "button"}
                          class="btn btn-primary me-2"
                          onClick={() =>
                            values?.agree !== true &&
                            setFieldError(
                              "agree",
                              "You must accept the terms and conditions"
                            )
                          }
                        >
                          Add
                        </button>
                        <button type="reset" class="btn btn-label-secondary">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </div>

        <Footer />
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};
